import { Link } from 'react-router-dom';
import { FaTwitter, FaLinkedin, FaYoutube } from 'react-icons/fa';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const sections = {
    marketSegments: {
      title: 'Market Segments',
      links: [
        { to: '/market-segments/stablecoin-issuers', text: 'Stablecoin Issuers' },
        { to: '/market-segments/rwa-token-issuers', text: 'RWA Token Issuers' },
        { to: '/market-segments/exchanges', text: 'Exchanges & Custodians' },
        { to: '/market-segments/etfs', text: 'ETFs & ETPs' },
        { to: '/market-segments/otc-market-makers', text: 'OTC & Market Makers' },
        { to: '/market-segments/crypto-fintechs', text: 'Crypto & Stablecoin Fintechs' },
      ],
    },
    accounting: {
      title: 'Accounting & Advisory',
      links: [
        { to: '/services/crypto-tax-services', text: 'Crypto Tax Services' },
        { to: '/services/outsourced-accounting', text: 'Outsourced Accounting & CFO' },
        { to: '/services/compliance-readiness', text: 'Compliance Readiness' },
        { to: '/services/treasury-strategic-reserve', text: 'Treasury & Strategic Reserve' },
        { to: '/services/process-operations-advisory', text: 'Process & Operations Advisory' },
      ],
    },
    audit: {
      title: 'Audit & Attest',
      links: [
        { to: '/services/financial-statement-audit', text: 'Financial Statement Audits' },
        { to: '/services/internal-control-examinations', text: 'Internal Control Examinations' },
        { to: '/attestations', text: 'Attestation Services' },
      ],
    },
    por: {
      title: 'Proof of Reserves',
      links: [
        { to: '/services/conventional-proof-of-reserves', text: 'Conventional POR' },
        { to: '/services/merkle-tree-proof-of-reserves', text: 'Merkle Tree POR' },
        { to: '/services/on-chain-proof-of-reserves', text: 'On-Chain POR' },
        { to: '/services/real-time-proof-of-reserves', text: 'Real-Time POR' },
      ],
    },
    about: {
      title: 'About',
      links: [
        { to: '/about', text: 'About Us' },
        { to: '/blog', text: 'News & Media' },
        { to: '/contact', text: 'Contact Us' },
      ],
    },
  };

  return (
    <footer className="bg-white text-gray-800">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2 lg:col-span-4 xl:col-span-2">
            <div className="mb-4">
              <Logo variant="default" />
            </div>
            <p className="text-gray-600 mb-6 text-sm max-w-xs">
              Professional audit and advisory services for the digital asset industry.
            </p>
            <div className="flex space-x-4 mb-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-accent transition-colors" aria-label="LinkedIn">
                <FaLinkedin size={22} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-accent transition-colors" aria-label="Twitter">
                <FaTwitter size={22} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-accent transition-colors" aria-label="YouTube">
                <FaYoutube size={22} />
              </a>
            </div>
            <Link to="/contact" className="btn-primary text-sm px-6 py-2.5">
              TALK TO AN EXPERT
            </Link>
          </div>

          {/* Dynamic Sections */}
          {Object.values(sections).map((section, i) => (
            <div key={i}>
              <h4 className="text-base font-semibold mb-4 tracking-wide">{section.title}</h4>
              <ul className="space-y-3 text-sm">
                {section.links.map((link, j) => (
                  <li key={j}>
                    <Link to={link.to} className="text-gray-600 hover:text-accent transition-colors">
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 mt-12 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {currentYear} Audit Financier. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;